import { render, staticRenderFns } from "./SelectCompanyComponent.vue?vue&type=template&id=0cc55109&"
import script from "./SelectCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./SelectCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports